import React from "react";
import { EuiBasicTable } from "@elastic/eui";

import { useSelector } from "react-redux";
import { useAddQueryNavigation } from "helpers/hooks/url";
import Content from "components/Content";

const List = () => {
  const users = useSelector(state => state.distance_rules.items);
  const collections = useSelector(state => state.collections.items);

  const addQuery = useAddQueryNavigation();

  const actions = [
    {
      name: "Löschen",
      description: "Diese Regel löschen",
      icon: "trash",
      color: "danger",
      type: "icon",
      onClick: e => {
        addQuery("deleteDistanceRule", e.id);
      }
    },
    {
      name: "Edit",
      description: "Diese Regel bearbeiten",
      icon: "pencil",
      type: "icon",
      isPrimary: true,

      onClick: e => {
        addQuery("editDistanceRule", e.id);
      }
    }
  ];

  const columns = [
    { field: "id", name: "#" },
    { field: "name", name: "Name" },
    { field: "description", name: "Beschreibung" },
    { field: "color", name: "Farbe" },

    { field: "distance", name: "Distanz" },
    {
      field: "source",
      name: "Ursprung",
      render(e) {
        return e.map(x => collections[x]?.name).join(", ");
      }
    },
    {
      field: "target",
      name: "Ziel",
      render(e) {
        return e.map(x => collections[x]?.name).join(", ");
      }
    },

    { field: "updated_at", name: "Letztes Update", dataType: "date" },
    { field: "created_at", name: "Erstellt am", dataType: "date" },

    { name: "Aktionen", actions }
  ];

  return (
    <Content title="Übersicht">
      <EuiBasicTable items={Object.values(users)} columns={columns} />
    </Content>
  );
};

export default List;
